import { render, staticRenderFns } from "./RecaptchaNotice.vue?vue&type=template&id=129ea31b&scoped=true&lang=pug"
import script from "./RecaptchaNotice.vue?vue&type=script&lang=js"
export * from "./RecaptchaNotice.vue?vue&type=script&lang=js"
import style0 from "./RecaptchaNotice.vue?vue&type=style&index=0&id=129ea31b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129ea31b",
  null
  
)

export default component.exports